export default __webpack_public_path__ + "static/media/gallery-9.72283a90.jpg";